module.exports = __webpack_public_path__ + "img/jsxqzs.45f49e0.png";